import type { ScreenTableSetting } from '../../hooks/DataTable/useTableSettings';

const DEFAULT_PAGE_SIZE = 20;
const DEFAULT_PAGE_SIZE_OPTIONS = [DEFAULT_PAGE_SIZE, 50, 100];

const DEFAULT_TABLE_SETTINGS: ScreenTableSetting = {
  columnOrder: [],
  columnPinning: {},
  columnSizing: {},
  columnVisibility: {},
  textEllipsis: true,
  compactMode: false,
};

const DENSE_TABLE_SETTINGS: ScreenTableSetting = {
  ...DEFAULT_TABLE_SETTINGS,
  compactMode: true,
};

const DEFAULT_TABLE_SETTING_OPTIONS = {
  showPageSizeSelect: true,
  showTextEllipsisSelect: true,
  showColumnSelect: true,
  showCompactModeSwitch: true,
  showViewTypeSelect: true,
};

const DETAIL_PAGE_SIZE = 5;
const DETAIL_PAGE_SIZE_OPTIONS = [DETAIL_PAGE_SIZE, 10, 20, 50, 100];
const DETAIL_TABLE_SETTINGS = {
  page: {
    pageIndex: 1,
    pageSize: DETAIL_PAGE_SIZE,
  },
  tableSettings: DENSE_TABLE_SETTINGS,
};
const DETAIL_TABLE_SETTING_OPTIONS = {
  showPageSizeSelect: true,
  showTextEllipsisSelect: true,
  showColumnSelect: false,
  showCompactModeSwitch: false,
  showViewTypeSelect: false,
};

export {
  DENSE_TABLE_SETTINGS,
  DETAIL_TABLE_SETTINGS,
  DETAIL_TABLE_SETTING_OPTIONS,
  DETAIL_PAGE_SIZE_OPTIONS,
  DETAIL_PAGE_SIZE,
  DEFAULT_TABLE_SETTINGS,
  DEFAULT_PAGE_SIZE_OPTIONS,
  DEFAULT_PAGE_SIZE,
  DEFAULT_TABLE_SETTING_OPTIONS,
};
